<template>
  <section class="appointSeviceGroupDiv">
    <viewTitle
      title="业务管理 / 车辆预约管理 / 预约业务组管理"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-button type="primary" @click="modifyTpl('', 'add')" size="small">
          新建业务组
        </el-button>
        <!-- </div> -->
        <!-- </section> -->
        <!-- 按钮组2 -->
        <!-- <section class="controler"> -->
        <!-- <div class="ctrLeft" style="width: 100%;"> -->
        <span class="rectl">状态: </span>
        <el-select
          class="ctl"
          clearable
          @clear="params.state = 0"
          v-model="params.state"
          placeholder="请选择状态"
          @change="changeState"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateOption"
            :key="index"
          ></el-option>
        </el-select>
        <el-input
          class="ctl rectl"
          style="width: 20% !important;"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
        >
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="业务组名称">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="包含业务">
          <template slot-scope="scope">
            <!-- {{ matchServiceName(scope.row.business_ids) }} -->
            {{ scope.row.business_names.join("、") || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            {{ scope.row.note || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1" class="color5E">正常</span>
            <span v-else-if="scope.row.state === 2" class="color67">
              已禁用
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item
                    @click.native.stop="modifyTpl(scope.row, 'edit')"
                    >编辑</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="delOrEnable(scope.row, 'forbid')"
                    v-if="scope.row.state === 1"
                    >禁用</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="delOrEnable(scope.row, 'start')"
                    v-if="scope.row.state === 2"
                    >启用</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="delOrEnable(scope.row, 'del')"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.show"
      width="30%"
      :show-close="dialogParams.title === '确认提醒'"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogParams.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.show = false" size="small">
          <span v-if="dialogParams.title === '确认提醒'">取 消</span>
          <span v-else>我知道了</span>
        </el-button>
        <el-button
          :class="dialogParams.type === 'del' ? 'btnConfirmDanger' : ''"
          :type="dialogParams.type === 'del' ? 'danger' : 'primary'"
          size="small"
          @click="confirm"
          v-loading.fullscreen.lock="fullscreenLoading"
          v-if="dialogParams.title === '确认提醒'"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.showModify"
      width="40%"
      :close-on-click-modal="false"
      :title="
        dialogParams.typeModify === 'add' ? '新建预约业务组' : '编辑预约业务组'
      "
    >
      <div>
        <el-form label-width="100px">
          <el-form-item
            label="业务组名称"
            :rules="[{ required: true, message: '' }]"
          >
            <el-input
              v-model="modifyParams.name"
              placeholder="请输入业务组名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="包含业务"
            :rules="[{ required: true, message: '' }]"
          >
            <el-select
              v-model="modifyParams.include"
              multiple
              placeholder="请选择包含业务"
              style="width: 100%;"
            >
              <el-option
                v-for="item in serviceOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="modifyParams.remark"
              placeholder="请输入备注（50字符以内）"
              rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">
          <span>取 消</span>
        </el-button>
        <el-button type="primary" @click="save" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      rowDataObj: {},
      params: {
        keyword: "", // 关键字搜索
        state: 0 // 状态
      },
      dialogParams: {
        show: false,
        title: "",
        content: "",
        type: "",
        showModify: false, // 编辑
        typeModify: "" // 编辑/添加
      },
      modifyParams: {
        id: 0, // id
        name: "", // 业务名称
        remark: "", // 备注
        include: [] // 包含业务
      },
      fullscreenLoading: false,
      maxSize: 0,
      tableData: [], // 表格数据
      stateOption: ["全部", "正常", "已禁用"],
      serviceOptions: []
    };
  },

  components: {
    pagi,
    viewTitle
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mixins: [mixinTableLyout],

  mounted() {
    // setTimeout(() => {
    //   this.resizeTableHeight();
    //   window.addEventListener(
    //     "resize",
    //     e => {
    //       //  初始化表格合适高度
    //       this.resizeTableHeight();
    //       console.log(e);
    //     },
    //     false
    //   );
    // }, 500);
    this.getList();
    this.getServiceList();
  },

  async activated() {},

  created() {},

  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 匹配业务名称
    matchServiceName(arr) {
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        this.serviceOptions.forEach(item => {
          if (item.id === arr[i]) {
            newArr.push(item.name);
          }
        });
      }
      return newArr.join("、");
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_business_group",
        data: {
          keyword: this.params.keyword,
          state: this.params.state,
          page_size: this.pageSize,
          page: this.page
        }
      });
      console.log(dataObj.data.data);
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 获取业务列表
    async getServiceList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_business",
        data: {
          pid: "",
          keyword: "",
          state: 1
        }
      });
      console.log(dataObj.data.data);
      let obj = dataObj.data.data,
        dest = [];
      // 按照父级进行分组
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].pid === "") {
          dest.push(obj[i]);
          for (let j = 0; j < obj.length; j++) {
            if (obj[j].pid === obj[i].id) {
              dest.push(obj[j]);
            }
          }
        }
      }
      this.serviceOptions = dest;
    },

    // 修改状态
    changeState() {
      this.page = 1;
      this.getList();
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 查看详情
    viewDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/rhqy/service/appoint/timeTplList/detail",
        query: {
          type: "edit"
        }
      });
    },

    // 查看详情
    modifyTpl(row, tag) {
      console.log(row);
      this.dialogParams.showModify = true;
      this.dialogParams.typeModify = tag;

      if (tag === "edit") {
        this.modifyParams.id = row.id;
        this.modifyParams.include = row.business_ids;
        this.modifyParams.name = row.name;
        this.modifyParams.remark = row.note;
      }
    },

    // 删除/禁用启用
    delOrEnable(row, tag) {
      this.dialogParams.type = tag;
      this.dialogParams.title = "确认提醒";
      this.dialogParams.show = true;
      this.rowDataObj = row;
      if (tag === "del") {
        this.dialogParams.content = `确认要删除“<span class="color67">${this.rowDataObj.name}</span>”业务组吗？<br />
        <span class="color67">删除后不可恢复！</span>`;
      } else if (tag === "forbid") {
        this.dialogParams.content = `确认要禁用“<span class="color67">${this.rowDataObj.name}</span>”业务组吗？`;
      } else if (tag === "start") {
        this.dialogParams.content = `确认要启用“<span class="color67">${this.rowDataObj.name}</span>”业务组吗？`;
      }
    },

    // 确认删除/禁用启用
    confirm() {
      this.dialogParams.show = false;
      let url = "";
      if (this.dialogParams.type === "del") {
        url = "/api/queue/admin/delete_business_group";
      } else if (
        this.dialogParams.type === "forbid" ||
        this.dialogParams.type === "start"
      ) {
        url = "/api/queue/admin/enable_business_group";
      }
      this.$common
        .http({
          url: url,
          data: {
            id: this.rowDataObj.id
          }
        })
        .then(res => {
          console.log(res);
          // this.dialogParams.content = `已成功删除“<span class="color67">${this.rowDataObj.name}</span>”业务组。`;
          if (this.dialogParams.type === "del") {
            this.$common.pcToastSuccess(
              `已成功删除“${this.rowDataObj.name}”业务组。`
            );
          } else if (this.dialogParams.type === "forbid") {
            this.$common.pcToastSuccess(
              `已成功禁用“${this.rowDataObj.name}”业务组。`
            );
          } else if (this.dialogParams.type === "start") {
            this.$common.pcToastSuccess(
              `已成功启用“${this.rowDataObj.name}”业务组。`
            );
          }
          // this.dialogParams.show = true;
          // this.dialogParams.title = "操作成功";
          this.getList();
          // setTimeout(() => {
          //   this.dialogParams.show = false;
          // }, 1500);
        });
    },

    // 保存表单
    save() {
      console.log("保存", this.modifyParams);
      if (this.modifyParams.name.trim() === "") {
        this.$common.pcToastFail("业务组名称不能为空");
        return false;
      }
      if (this.modifyParams.include.length === 0) {
        this.$common.pcToastFail("请选择包含业务");
        return false;
      }
      if (this.modifyParams.remark.trim().length > 50) {
        this.$common.pcToastFail("备注不能超过50个字符");
        return false;
      }

      this.$common
        .http({
          url: "/api/queue/admin/save_business_group",
          data: {
            id: this.modifyParams.id,
            name: this.modifyParams.name,
            note: this.modifyParams.remark,
            business_ids: JSON.stringify(this.modifyParams.include)
          }
        })
        .then(res => {
          console.log(res);
          this.dialogParams.showModify = false;
          if (res.data.data) {
            if (this.dialogParams.typeModify === "add") {
              this.$common.pcToastSuccess("添加成功");
            } else {
              this.$common.pcToastSuccess("保存成功");
            }
          }
          this.getList();
          // 重置表单
          for (let key in this.modifyParams) {
            this.modifyParams[key] = "";
          }
          this.modifyParams.include = [];
          this.modifyParams.id = 0;
        });
    },

    // 取消
    cancel() {
      this.dialogParams.showModify = false;
      for (let key in this.modifyParams) {
        this.modifyParams[key] = "";
      }
      this.modifyParams.include = [];
      this.modifyParams.id = 0;
    }

    // 重置高度
    // resizeTableHeight() {
    //   const BANNER_HEIGHT = 25; // 头部导航高度
    //   const PADDING = 24; // padding
    //   const ETC = 260; // 头部 和 底部导航高度
    //   var offsetHeihgt = window.innerHeight - BANNER_HEIGHT - PADDING * 2;
    //   this.maxSize = offsetHeihgt - ETC;
    // }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.appointSeviceGroupDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
</style>
